












































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { Thematique } from '@/orrm/model/thematique'
import { Phenomene } from '@/orrm/model/phenomene'

export interface FilterCriterias {
  label: string;
  thematics: Thematique[];
  phenomenes: Phenomene[];
  profile: ('informatif' | 'technique')[];
}

@Component
export default class LayerFilter extends Vue {
  @Prop({
    default: () => {
      return {
        label: '',
        thematics: [],
        phenomenes: [],
        profile: []
      }
    }
  })
  value: FilterCriterias

  @Prop({ default: () => [] })
  thematics: Thematique[]

  @Prop({ default: () => [] })
  phenomenes: Phenomene[]

  open = false
  filters: FilterCriterias = {
    label: '',
    thematics: [],
    phenomenes: [],
    profile: []
  }

  onFiltersChanged () {
    this.$emit('input', this.filters)
  }

  @Watch('value', { immediate: true })
  onValueChanged () {
    this.filters = this.value
  }
}
